import React from "react";
import { Card, Form, Row, Col, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../api/fileUpload/fileUpload.hooks";

const HeroSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleFileUpload = async (file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange("backgroundImage", res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Hero Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading || ""}
                  onChange={(e) => handleChange("heading", e.target.value)}
                  placeholder="Enter hero heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Paragraph</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={data.paragraph || ""}
                  onChange={(e) => handleChange("paragraph", e.target.value)}
                  placeholder="Enter hero paragraph"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Background Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload(e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">Uploading...</div>
                )}
                {data.backgroundImage && (
                  <div className="mt-2">
                    <Image
                      src={data.backgroundImage}
                      alt="Hero background preview"
                      thumbnail
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Image Identifier</Form.Label>
                <Form.Control
                  type="text"
                  value={data.imageIdentifier || ""}
                  onChange={(e) =>
                    handleChange("imageIdentifier", e.target.value)
                  }
                  placeholder="e.g. hero"
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </Card>
  );
};

export default HeroSection;
